<template>
	<div id="has-many-form-inputs">
		<div class="input text required" v-for="(field, fieldKey) in prop_fields" :key="fieldKey">
			<label>{{ field.label }}</label>

			<input v-if="field.element == 'input'"
				:type="field.type"
				:name="generateInputName(prop_group_key, field.name)"
				v-model="prop_group_data[field.name]"
				:required="field.required"
				:class="field.class">

			<div v-else-if="field.element == 'checkbox'">
				<input type="hidden" :name="generateInputName(prop_group_key, field.name)" value="0">
				<input type="checkbox" :name="generateInputName(prop_group_key, field.name)" 
					@click="toggleCheckbox(prop_group_key, field.name)"
					v-model="prop_group_data[field.name]"
					value="1">
			</div>

			<textarea v-else-if="field.element == 'textarea'"
				:name="generateInputName(prop_group_key, field.name)"
				v-model="prop_group_data[field.name]"
				:required="field.required"
				:class="field.class"
			></textarea>

			<slim-uploader v-else-if="field.element == 'slim-uploader'"
					:fieldname="generateInputName(prop_group_key, field.name)"
					:image="getProductImageUrl(prop_group_data)"
					required="true"
					label="Select Image"
					service="/ajax/slim-image-upload"
					push="false"
					ratio="free"
				>
			</slim-uploader>

			<p v-else>Invalid Element Type</p>
		</div>
	</div>
</template>

<script>
	import vSelect from "vue-select"
	import SlimUploader from '../components/SlimUploader.vue'

	export default {
		components: {vSelect, SlimUploader},
		name: 'hasManyFormWrapper',
		props: {
			prop_fields: { type: Array, required: true },
			prop_group_key: { required: true },
			prop_group_data: {},
			prop_parent_field_key: { required: true }
		},
		methods: {
			generateInputName: function(key, field) {
				return this.prop_parent_field_key + "[" + key + "][" + field + "]";
			},
			toggleCheckbox: function(prop_group_key, field_name) {
				// emit toggle togglePrimary event checkbox is toggled (unchecks other inputs)
				if(field_name == 'is_primary') {
					this.$emit('togglePrimary', prop_group_key);
				}
			},
			getProductImageUrl: function(entity) {
				if(entity.path) {
					return entity.cdn_url ? entity.cdn_url : "/" + entity.path;
				}

				return false;
			},
		},
		mounted: function() {
			let vm = this;
			setTimeout(function() {
				var elements = $(vm.$el).find('.wysiwyg');
				if(elements.length) {
					elements.redactor({
						plugins: ['source'],
						imageUpload: '/ajax/redactor-upload',
						imageResizable: true,
						imagePosition: true,
						callbacks: {
							uploadBeforeSend: function(xhr) {
								let token = Cookies.get('csrfToken');
								if(token) {
									xhr.setRequestHeader('X-CSRF-Token', token);
								}
							}
						}
					});
				}
			}, 100);
		},
	}
</script>

<style lang="scss" scoped>
	#has-many-form-inputs {

	}
</style>


// WEBPACK FOOTER //
// assets/js/vue/elements/HasManyFormInputs.vue